import { LiveIntegrationColumn } from "frontend/canvas-designer-new/elements-toolbar/widgets/live-integration/utils";

export const EMPTY_DEFAULT_COLUMN: LiveIntegrationColumn = {
  id: "empty",
  settings: {},
  title: "Column",
  type: "status",
};

export const SUPPORTED_COLUMN_TYPES = ["status", "dropdown"];

export interface DropdownLabel {
  id: number;
  name: string;
}
